export default __webpack_public_path__ + "static/media/bci-12-hover.b9eb5efa.svg";